<template>
  <div
    class="pick-up__single"
    :class="{'pick-up__single--full': order.status != 'empty'}"
    v-if="hasFeature('FEATURE_ORDERBOXES') && order.box"
  >
    <template v-if="order.status != 'empty'">
      <div class="pick-up__box">box {{ order.box }}</div>
      <div class="pick-up__number">{{ order.number | fwgshortorder }}</div>
      <div class="pick-up__text">{{ order.order_label }}</div>
    </template>
    <div v-else class="pick-up__box pick-up__box--empty">BOX {{ order.box }}</div>
  </div>
  <div class="grid__single" v-else>
    <div class="grid__number">{{ order.number | fwgshortorder }}</div>
    <div class="grid__text">{{ order.order_label }}</div>
  </div>
</template>

<script>
export default {
  props: {
    order: {
      required: true
    },
  },
};
</script>

<style>
</style>
